<script lang="ts" setup>
defineProps<{
  title?: string | boolean | null | undefined
}>()

function gotoBack() {
  NeoAdVideoForThirdParty.popBack()
}
</script>

<template>
  <div
    class="w-full fixed top-8 flex items-center z-10 bg-transparent"
  >
    <div class="p-2 pl-4" @click="gotoBack()">
      <i-icon-park-outline-left
        class="transition-all duration-200"
        :class="title ? 'w-4 h-4 text-#999' : 'w-6 h-6'"
      />
    </div>
    <p v-show="title" class="text-#999">
      {{ title }}
    </p>
  </div>
</template>
